import { createRoute } from '@tanstack/react-router'
import rootRoute from '../rootRoute'
import AdminTabs from './AdminTabs'
import AdminScrapersCRUD from '@/components/admin/AdminScrapersCRUD'
import { adminRouteLoader } from '@/lib/auth'
import { spacing } from '@/components/ui'

function AdminScrapersView() {
  return (
    <div
      style={{
        maxWidth: 'var(--container-max)',
        margin: '0 auto',
        padding: 'var(--space-8) var(--gutter) var(--space-20)',
      }}
    >
      <AdminTabs />
      <div className="oumma-overline" style={{ marginBottom: spacing.sm }}>
        Espace admin
      </div>
      <h1 style={{ fontSize: 'var(--text-h1)', margin: '0 0 28px' }}>
        Scrapers
      </h1>
      <AdminScrapersCRUD />
    </div>
  )
}

export const adminScrapersManageRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/admin/scrapers',
  loader: adminRouteLoader,
}).lazy(() => import('./AdminScrapersView.lazy').then((m) => m.Route))

export default AdminScrapersView
